import css from 'styled-jsx/css';

export default css`
    .Loading {
        height: 0;
        width: 0;
        padding: 15px;
        border: 6px solid #ccc;
        border-right-color: #888;
        border-radius: 22px;
        -webkit-animation: ${'rotate'} 1s infinite linear;
        animation: ${'rotate'} 1s infinite linear;
    }
`;
